






import { Component, Vue } from "vue-property-decorator";
import PageTabNavigation from "@/components/app/tabs/page-tab-navigation.vue";
import { IRoute } from "@/@types/routes/routes";
@Component({
  name: "Administration",
  components: { PageTabNavigation },
})
export default class Administration extends Vue {
  routeLinksAdmin: string[] = [];

  createRoutes(): void {
    const routes: Array<IRoute> = this.$store.getters.ROUTER_STATE;
    const route = routes.find((el: IRoute) => el.name == this.$options.name);
    if (!routes.length || !route) {
      this.routeLinksAdmin.push("AdministrationServers");
      return;
    }

    for (const r of route.children) {
      this.routeLinksAdmin.push(r);
    }
  }

  mounted(): void {
    this.createRoutes();
  }
}
